import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import ReactTable from "react-table";
import { useTranslation } from 'react-i18next';
import CsvDownloader from 'react-csv-downloader';
import Select from 'react-select';
import { Link } from "react-router-dom";

// ui icons
import Assignment from "@material-ui/icons/Assignment";
import Edit from "@material-ui/icons/Edit";
import DeleteForever from "@material-ui/icons/DeleteForever";
import CreditCard from "@material-ui/icons/CreditCard";
import Subtitles from "@material-ui/icons/Subtitles";
import AttachMoney from "@material-ui/icons/AttachMoney";
import Event from "@material-ui/icons/Event";
import Grade from "@material-ui/icons/Grade";

// ui components
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import Slide from "@material-ui/core/Slide";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import CircularProgress from '@material-ui/core/CircularProgress';

// core components 
import Card from "beaktShared/components/Card/Card.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import InputAdornment from '@material-ui/core/InputAdornment';
import NavPills from "beaktShared/components/NavPills/NavPills.js";
import PagamentoCartao from "beaktClinic/views/Venda/Pagamentos/PagamentoCartao"
import PagamentoDinheiro from "beaktClinic/views/Venda/Pagamentos/PagamentoDinheiro"
import PagamentoCheque from "beaktClinic/views/Venda/Pagamentos/PagamentoCheque"
import PagamentoBoleto from "beaktClinic/views/Venda/Pagamentos/PagamentoBoleto"
import PagamentoOutros from "beaktClinic/views/Venda/Pagamentos/PagamentoOutros"
import Clearfix from 'beaktShared/components/Clearfix/Clearfix';

// services
import { MaskCPF, MaskCel, MaskCEP, transformValueFloattoFormated, formateDate, MaskDate } from "beaktShared/helpers/masks";
import { UseGetApiSimple, UsePostApi, UsePutApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";

// components
import AlteracaoVendaCliente from './Components/AlteracaoVendaCliente';
import AlteracaoVendaPagamento from './Components/AlteracaoVendaPagamento';

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function AlteracaoVendaForm({ detalheVenda, CallbackEditVenda }) {
    const { t } = useTranslation();
    
    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification(prev => ({ ...prev, show: false }));
        }, 6000);
    };

    const [step, setstep] = React.useState(null);
    
    const [venda, setvenda] = React.useState(null);

    useEffect(() => {
        setvenda(detalheVenda);

        setstep(0);
    }, [detalheVenda]);

    const handleProximoStep = (_detalheVenda) => {
        setstep(1);
        setvenda(_detalheVenda);
    }

    const handleVoltarPagamento = (_detalheVenda) => {
        setstep(0);
        setvenda(_detalheVenda);
    }

    const [loadingForm, setLoadingForm] = React.useState(false);

    const handleFinalizar = (_detalheVenda) => {        
        let endPoint = "vendas/salvaralteracaovenda/"
        setLoadingForm(true);
        UsePostApi(endPoint,_detalheVenda).then(result=>{               
            setLoadingForm(false); 
            if(result.status !== 200)
            {                     
                showNotification("Ocorreu um erro ao tentar gravar a alteração!",'danger');
                return false; 
            } 
            CallbackEditVenda(result.data);
            return true;                
        });          
    }
   
    return (

        <div>
            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification(prev => ({ ...prev, show: false }))}
                close
            />
            <GridContainer className="no-print">
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Edit />
                            </CardIcon>
                        </CardHeader>
                        <CardBody>
                            {step == 0 &&
                                <AlteracaoVendaCliente detalheVenda={venda} handleVoltar={CallbackEditVenda} handleProximoStep={handleProximoStep}></AlteracaoVendaCliente>
                            }
                            {step == 1 &&
                                <AlteracaoVendaPagamento detalheVenda={venda} handleVoltar={handleVoltarPagamento} handleFinalizar={handleFinalizar} ></AlteracaoVendaPagamento>
                            }
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}

